export default "__VITE_ASSET__xmvuEQH3__"